/**
 * TAS Command — Sistema Digitale di Gestione Operazioni SAR
 *
 * Copyright (c) 2026 Matteo MESSINA, Alfonso CECERE
 * Tutti i diritti riservati.
 *
 * Sviluppato dagli autori a titolo personale, al di fuori
 * dell'orario di servizio e senza utilizzo di risorse o
 * strumentazione dell'amministrazione di appartenenza.
 *
 * Qualsiasi riproduzione, distribuzione o utilizzo non
 * autorizzato è vietato ai sensi della L. 633/1941.
 *
 * Autori:
 *   Matteo MESSINA  — VE, Comando VVF Benevento, Servizio TAS
 *   Alfonso CECERE  — VE, Comando VVF Benevento, Servizio TAS
 */

/**
 * offlineDb.js — Database IndexedDB per la coda offline
 *
 * Usa Dexie.js come wrapper di IndexedDB.
 * Tabella `pendingOps`: operazioni di scrittura in attesa di sincronizzazione.
 * Tabella `failedOps`:  operazioni che il server ha RIFIUTATO in modo definitivo.
 */
import Dexie from 'dexie';

export const db = new Dexie('TASCommandOffline');

db.version(1).stores({
  // ++id = chiave autoincrementale, timestamp e opType sono indicizzati
  pendingOps: '++id, timestamp, opType',
});

// v2 — `failedOps`: le operazioni rifiutate NON si cancellano piu'.
// Prima un 4xx permanente (o un 409) faceva `pendingOps.delete()` e incrementava un
// contatore: l'utente vedeva "N operazioni non sincronizzate — riprova" ma non c'era
// piu' niente da riprovare, e il contenuto scritto da una persona in campo era perso
// senza lasciare traccia. Ora l'op viene spostata qui con payload, errore e stato
// HTTP, e resta finche' l'operatore non la riprova o la scarta esplicitamente.
// Migrazione additiva: `pendingOps` non viene toccata.
db.version(2).stores({
  pendingOps: '++id, timestamp, opType',
  failedOps:  '++id, failedAt, opType',
});
